import { $applyNodeReplacement, DecoratorNode, DOMConversionMap, DOMExportOutput, NodeKey, SerializedLexicalNode, Spread } from 'lexical';
import { InlineFrame, InlineFrameProperties } from '../components/InlineFrame';

export type SerializedInlineFrameNodeProperties =
{
    properties?: InlineFrameProperties
}

export type SerializedInlineFrameNode = Spread<SerializedInlineFrameNodeProperties, SerializedLexicalNode>;

export function $createInlineFrameNode(properties: InlineFrameProperties): InlineFrameNode
{
    return $applyNodeReplacement(new InlineFrameNode(properties));
}

export class InlineFrameNode extends DecoratorNode<JSX.Element>
{
    static getType(): string
    {
        return 'iFrame';
    }

    static clone(node: InlineFrameNode): InlineFrameNode
    {
        return new InlineFrameNode(node.properties, node.__key);
    }

    static importJSON(serializedNode: SerializedInlineFrameNode): InlineFrameNode
    {
        const node = $createInlineFrameNode(serializedNode.properties ?? {  src: '' });
        return node;
    }

    static importDOM(): DOMConversionMap
    {
        const convertIFrame = (el: HTMLElement) =>
        {
            const properties =
            {
                src: el.getAttribute('src') || '',
                // eslint-disable-next-line no-undefined
                title: el.getAttribute('title') || undefined,
                // eslint-disable-next-line no-undefined
                width: el.getAttribute('width') ? Number(el.getAttribute('width')) : undefined,
                // eslint-disable-next-line no-undefined
                height: el.getAttribute('height') ? Number(el.getAttribute('height')) : undefined,
                // eslint-disable-next-line no-undefined
                allow: el.getAttribute('allow') || undefined,
                // eslint-disable-next-line no-undefined
                sandbox: el.getAttribute('sandbox') || undefined,
                // eslint-disable-next-line no-undefined
                referrerPolicy: el.getAttribute('referrerpolicy') || undefined,
                // eslint-disable-next-line no-undefined
                loading: el.getAttribute('loading') || undefined,
                // eslint-disable-next-line no-undefined
                allowFullScreen: el.hasAttribute('allowfullscreen') ? '' : undefined,
            };
            return { node: $createInlineFrameNode(properties) };
        };
        const iframe: any = () => ({ conversion: convertIFrame, priority: 1 });
        return { iframe };
    }

    exportDOM(): DOMExportOutput
    {
        const el = document.createElement('iframe');
        const props = this.properties ?? { src: '' };

        if (props.src) { el.setAttribute('src', props.src); }
        if (props.title) { el.setAttribute('title', props.title as string); }
        if (typeof props.width === 'number' && props.width > 0) { el.setAttribute('width', String(props.width)); }
        if (typeof props.height === 'number' && props.height > 0) { el.setAttribute('height', String(props.height)); }

        if (props.allow) { el.setAttribute('allow', props.allow as string); }
        if (props.sandbox) { el.setAttribute('sandbox', props.sandbox as string); }
        if (props.referrerPolicy) { el.setAttribute('referrerpolicy', props.referrerPolicy as string); }
        if (props.loading) { el.setAttribute('loading', props.loading as string); }
        if (props.allowFullScreen) { el.setAttribute('allowfullscreen', ''); }

        // exclude to lista kontrolowana, żeby nie duplikować powyższych
        // const exclude = new Set(['src','title','width','height','allow','sandbox','referrerpolicy','loading','allowfullscreen']);
        // setAttributes?.(el, (props as any).attrs || {}, exclude);

        return { element: el };
    }

    properties?: InlineFrameProperties;

    constructor(properties?: InlineFrameProperties, key?: NodeKey)
    {
        super(key);
        this.properties = properties;
    }

    createDOM(): HTMLElement
    {
        const span = document.createElement('span');
        span.className = 'resizable';
        return span;
    }

    updateDOM(): false
    {
        return false;
    }

    decorate()
    {
        try
        {
            return <InlineFrame nodeKey={this.getKey()} properties={this.properties} />;
        }
        catch (error) { /* empty */ }
        return <span>{this.properties?.src}</span>;
    }

    exportJSON(): SerializedInlineFrameNode
    {
        return { type: 'iFrame', version: 1, properties: this.properties };
    }

    setSize(width: number, height: number)
    {
        const writable = this.getWritable();
        writable.properties = writable.properties || { src: '' };
        writable.properties.width = width;
        writable.properties.height = height;
    }
}